import React, { useState } from "react";
import Swal from "sweetalert2";

interface GameItem {
  href: string;
  imgSrc: string;
  alt?: string;
  isActive: boolean;
}

const games: GameItem[] = [
  {
    href: "/casino",
    imgSrc: "/assets/ag.png",
    alt: "AG Asia Gaming",
    isActive: false,
  },
  {
    href: "/casino",
    imgSrc: "/assets/evoluton.png",
    alt: "Evolution",
    isActive: false,
  },
  {
    href: "/casino/lobby",
    imgSrc: "/assets/ae-sexy.png",
    alt: "AE Sexy",
    isActive: true,
  },
  {
    href: "/casino",
    imgSrc: "/assets/wm.png",
    alt: "WM Casino",
    isActive: false,
  },
  {
    href: "/casino",
    imgSrc: "/assets/venus.png",
    alt: "Venus Casino",
    isActive: false,
  },
];

const CustomLobby: React.FC = () => {
  const [mobileIndex, setMobileIndex] = useState(2);

  const handleGameSelect = (game: GameItem, e?: React.MouseEvent) => {
    if (!game.isActive) {
      if (e) e.preventDefault();
      Swal.fire({
        title: "Sảnh đang cập nhật",
        html:
          "<p style='font-size:14px;margin-top:6px'>Vui lòng quay lại sau ít phút nữa nhé.</p>",
        icon: "info",
        confirmButtonText: "Đã hiểu",
        background: "#061620",
        color: "#ffffff",
        confirmButtonColor: "#00ff99",
        backdrop: "rgba(0,0,0,0.7)",
        showClass: {
          popup: "swal2-noanimation",
          backdrop: "swal2-backdrop-show",
        },
        hideClass: {
          popup: "",
          backdrop: "swal2-backdrop-hide",
        },
      });
      return;
    }

    window.location.href = game.href;
  };

  const goPrev = () => {
    setMobileIndex((prev) => (prev === 0 ? games.length - 1 : prev - 1));
  };

  const goNext = () => {
    setMobileIndex((prev) => (prev === games.length - 1 ? 0 : prev + 1));
  };

  return (
    <div className="relative w-full max-w-screen-full mx-auto px-2 md:px-4">
      {/* Desktop: keep existing layout */}
      <div className="hidden md:flex flex-wrap justify-center items-end gap-2 md:gap-5 mt-6 md:mt-10">
        {games.map((game, index) => (
          <div
            key={index}
            className="cursor-pointer transition-transform duration-300 hover:scale-105"
          >
            <a href={game.href} onClick={(e) => handleGameSelect(game, e)}>
              <img
                src={game.imgSrc}
                alt={game.alt || ""}
                className={`object-cover block ${
                  index === 2 ? "game-card-image game-card-image--main" : "game-card-image game-card-image--side"
                }`}
                style={{
                  width: index === 2 ? 388 : 271,
                  height: index === 2 ? 508 : 406,
                }}
              />
            </a>
          </div>
        ))}
      </div>

      {/* Mobile: slider one image at a time */}
      <div className="md:hidden mt-4">
        <div className="w-full flex justify-center">
          <button
            type="button"
            onClick={() => handleGameSelect(games[mobileIndex])}
            className="cursor-pointer transition-transform duration-200 active:scale-95"
            aria-label={games[mobileIndex].alt || "game"}
          >
            <img
              src={games[mobileIndex].imgSrc}
              alt={games[mobileIndex].alt || ""}
              className="mobile-slide-image"
            />
          </button>
        </div>

        <div className="flex items-center justify-center gap-2 mt-4">
          {games.map((_, idx) => (
            <button
              key={idx}
              type="button"
              onClick={() => setMobileIndex(idx)}
              className={`mobile-dot ${idx === mobileIndex ? "mobile-dot-active" : ""}`}
              aria-label={`slide-${idx + 1}`}
            />
          ))}
        </div>

        <div className="flex justify-center items-center gap-8 mt-4 text-white">
          <button
            type="button"
            onClick={goPrev}
            className="mobile-nav-btn"
          >
            BACK
          </button>
          <button
            type="button"
            onClick={goNext}
            className="mobile-nav-btn"
          >
            NEXT
          </button>
        </div>
      </div>

      <style>{`
        .game-card-image--main {
          width: 388px !important;
          height: 508px !important;
        }
        .game-card-image--side {
          width: 271px !important;
          height: 406px !important;
        }
        @media (max-width: 1024px) {
          .game-card-image--main {
            width: 300px !important;
            height: 392px !important;
          }
          .game-card-image--side {
            width: 210px !important;
            height: 314px !important;
          }
        }
        @media (max-width: 768px) {
          .mobile-slide-image {
            width: min(78vw, 315px);
            height: auto;
            max-height: 64vh;
            object-fit: contain;
            display: block;
          }
          .mobile-dot {
            width: 28px;
            height: 8px;
            border-radius: 999px;
            border: 1px solid rgba(255,255,255,0.4);
            background: rgba(255, 255, 255, 0.15);
          }
          .mobile-dot-active {
            background: #00d89f;
            border-color: #00d89f;
            box-shadow: 0 0 8px rgba(0, 216, 159, 0.7);
          }
          .mobile-nav-btn {
            font-size: 24px;
            font-weight: 700;
            color: #fff;
            text-shadow: 0 0 8px rgba(0,0,0,0.8);
          }
        }
      `}</style>
    </div>
  );
};

export default CustomLobby;
